import React, {useState, useEffect} from 'react';

import Modal from 'react-bootstrap/Modal';
import StepWizard from "react-step-wizard";

import moment from 'moment';

import * as XLSX from 'xlsx';

import utility from '@app/lib/utility';
import ContractCompnent from '../Contract/List/Component.js';
import AddContractModal from './AddContractModal.js';
import ModifyContractModal from './ModifyContractModal.js';
import MasterContractModal from './MasterContractModal.js';


const ContractControlBtn = ({branchId, nurseryId, nurseryName, nurseryStatus, tableId, bizApp, serviceAppList, appAuthTypeList, list, director, seasonInfo, directorName, address, isRecontractModal, isBranchCall = false}) => {
	useEffect(() => {
        return () => {};
    }, [branchId, nurseryId, nurseryName, tableId, bizApp, serviceAppList, appAuthTypeList, list]);

	const saveContractTableXlsx = () => {
		
		if(!list || list.length === 0) {
			alert('계약이 존재하지 않습니다.'); 
			return false;
		}
		
		const excelHandler = {
	        getExcelFileName : function(){
	            return `${nurseryName || '-'} 계약 정보.xlsx`;
	        },
	        getSheetName : function(){
	            return `${nurseryName || '-'} 계약 정보`;
	        },
	        getExcelData : function(){
	            return document.getElementById(tableId); 
	        },
	        getWorksheet : function(){
	            return XLSX.utils.table_to_sheet(this.getExcelData());
	        }
		};

	    var wb = XLSX.utils.book_new();
	    var newWorksheet = excelHandler.getWorksheet();
	    XLSX.utils.book_append_sheet(wb, newWorksheet, excelHandler.getSheetName());

	    var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
		utility.download2Excel(wbout, excelHandler.getExcelFileName());
	}
	
	const saveContractTableAsImg =() => {
		if(!list || list.length === 0) {
			alert('계약이 존재하지 않습니다.'); 
			return false;
		}   
		utility.downloadHtml2Png(document.getElementById(tableId), `${nurseryName || '-'} 계약 정보`);
	}

    if(!bizApp || !serviceAppList || !appAuthTypeList) {
        return <></>;
    }

	let result = null;

	if(list && list.length > 0) {
		result = (
			<>	
				<div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mt-2">
					<button
						className="btn btn-sm btn-outline-secondary mr-2"
						onClick={saveContractTableXlsx}
					>
						<i className="fas fa-table mr-1" />다운로드
					</button>
					<button
						className="btn btn-sm btn-outline-secondary"
						onClick={saveContractTableAsImg}
					>
						<i className="fas fa-image mr-1" />이미지 저장
					</button>
	    		</div>
	    		<div className="col-xl-4 col-lg col-md-12 col-sm-12 col-12 mt-0">
	    		</div>
	    		{branchId > 0 && (
	    			<>
	    				<div className="col-xl-2 col-lg col-md-6 col-sm-6 col-6 mt-2">
			    			<ModifyContractModal
			    				branchId={branchId}
			    				nurseryId={nurseryId}
			    				nurseryName={nurseryName}
								directorName={directorName}
								address={address}
			    				bizApp={bizApp}
                                serviceAppList={serviceAppList}
								appAuthTypeList={appAuthTypeList}
			    				list={list}
			    				seasonInfo={seasonInfo}
								disabled={isBranchCall && (nurseryStatus != 'active')}
			    			/>
			    		</div>
			    		<div className="col-xl-2 col-lg col-md-6 col-sm-6 col-6 mt-2">
			    			<AddContractModal
			    				branchId={branchId}
			    				nurseryId={nurseryId}
			    				nurseryName={nurseryName}
								directorName={directorName}
								address={address}
			    				bizApp={bizApp}
                                serviceAppList={serviceAppList}
								appAuthTypeList={appAuthTypeList}
			    				list={list}
								disabled={isBranchCall && (nurseryStatus != 'active')}
			    			/>
			    		</div>
	    			</>
	    		)}
	    		{branchId === 0 && (
	    			<>
	    				<div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 mt-2" />
			    		<div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 mt-2">
			    			<MasterContractModal
			    				branchId={branchId}
			    				nurseryId={nurseryId}
			    				nurseryName={nurseryName}
								directorName={directorName}
								address={address}
			    				bizApp={bizApp}
                                serviceAppList={serviceAppList}
								appAuthTypeList={appAuthTypeList}
			    				list={list}
			    			/>
			    		</div>
	    			</>
	    		)}
				
    		</>
		)
	} else {
		result = (
			<>	
				<div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mt-2">
					<button
						className="btn btn-sm btn-outline-secondary mr-2"
						onClick={saveContractTableXlsx}
					>
						<i className="fas fa-table mr-1" />다운로드
					</button>
					<button
						className="btn btn-sm btn-outline-secondary"
						onClick={saveContractTableAsImg}
					>
						<i className="fas fa-image mr-1" />이미지 저장
					</button>
				</div>
	    		<div className="col-xl-6 col-lg-3 col-md-6 col-sm-12 col-12 mt-0 text-warning text-right" style={{lineHeight: '51px', verticalAlign: 'middle'}}>
					{isBranchCall && (nurseryStatus != 'active') && (
						<span>
							원 등록이 완료된 후 [계약 등록]이 가능합니다.
						</span>
					)}
	    		</div>
	    		<div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 mt-2">
	    			{branchId > 0 && (
						<AddContractModal
							branchId={branchId}
							nurseryId={nurseryId}
							nurseryName={nurseryName}
							directorName={directorName}
							address={address}
							bizApp={bizApp}
							serviceAppList={serviceAppList}
							appAuthTypeList={appAuthTypeList}
							list={list}
							disabled={isBranchCall && (nurseryStatus != 'active')}
						/>
	    			)}
	    		</div>
    		</>
		)
	}

	return (
		<div className="row">
			{result}
		</div>
	);
}


export default ContractControlBtn;